// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WdAYR","colBig":"styles_colBig__5fI1O","colSmall":"styles_colSmall__3PyIT"};